<script setup lang="ts">
import settingService from '@/services/ide/settings/setting.service'
import ideModal from '@/components/ide/ide/IdeModal.vue'
import utilModelsService from '@/services/util.models.service'
import { IDEVIEWMODELS } from '@/utils/models'
/**
 * Clear current project
 */
const clearProject = () => {
  settingService.clearProject()
  settingService.closePopup()
  utilModelsService.openModal(IDEVIEWMODELS.STARTCODING)
}
</script>

<template>
  <ideModal title="New Project" class="sm:mt-[8vh]">
    <div class="flex h-full flex-col sm:min-h-[160px]">
      <p class="text-primary mt-8 text-center text-base sm:mt-4 md:mt-8">
        Do you want to clear current project?
      </p>
      <div class="my-4 flex w-full justify-center gap-5 sm:my-auto">
        <button
          class="btn btn-primary w-max rounded px-6 py-2 text-sm sm:w-max"
          @click="clearProject"
        >
          Yes
        </button>
        <button
          @click="settingService.closePopup()"
          class="btn btn-quaternary-static w-max rounded px-6 py-2 text-sm sm:w-max"
        >
          No
        </button>
      </div>
    </div>
  </ideModal>
</template>
